import "./index.marko?hydrate";
window.$initComponents && $initComponents();
